<template>
	<a v-if="shouldUseA" :href="to.toString()" :target="_target" v-bind="$attrs">
		<slot/>
	</a>
	<router-link
		v-else
		v-bind="$props">
		<slot/>
	</router-link>
</template>
<script>

export default {
	name: "AppLink",

	props: {
		to: {
			required: true,
			type: [Object, String],
		},
		useA: {
			required: false,
			type: Boolean,
			default() {
				return false;
			},
		},
		target: {
			required: false,
			type: String,
			default() {
				return "self";
			},
		},
	},

	computed: {
		shouldUseA() {
			return this.useA || this.to.toString().startsWith("http");
		},
		_target() {
			return "_" + this.target;
		},
	},
};
</script>
